<form #formulario="ngForm">
    <mat-accordion>

        <mat-expansion-panel [expanded]="openFormCadastro" (closed)="openFormCadastro = false">
            <mat-expansion-panel-header>
                <mat-panel-title>Dados da fatura</mat-panel-title>
            </mat-expansion-panel-header>

            <!-- DADOS INICIAIS -->
            <mat-toolbar class="titulopartes">Dados Iniciais</mat-toolbar>
            <div fxLayout="row" fxLayoutGap="50px" style="margin-top: 10px; margin-bottom: 10px" fxFlexFill>
                <mat-form-field fxFlex="200px" fxFlexOffset="20px">
                    <input [(ngModel)]="fatura.dataVencimento" 
                            (input)="onMascaraDataInput($event)" 
                            matInput name="dataVencimento" 
                            [matDatepicker]="dataVencimento"
                            [min]="movimentacoes.dataDocumento"
                            placeholder="Data de vencimento"
                            required>
                    <mat-datepicker-toggle matSuffix [for]="dataVencimento">
                    </mat-datepicker-toggle>
                    <mat-datepicker #dataVencimento></mat-datepicker>

                    <mat-error>Deve ser superior a data do documento</mat-error> 
                </mat-form-field>

                <mat-form-field fxFlex="160px">
                    <input [(ngModel)]="fatura.valor" 
                            currencyMask name="valorFatura" 
                            placeholder="Valor da Fatura" 
                            matInput maxlength="13"
                            [options]="{ prefix: '', thousands: '.', decimal: ',' }" 
                            required/>
                    <span matPrefix> R$&nbsp; </span>
                </mat-form-field>

                <mat-form-field fxFlex="80px" >
                    <input type="number" 
                            [(ngModel)]="fatura.numeroParcela" 
                            matInput min="0" 
                            maxlength="10" name="qtdParcelas"
                            placeholder="Parcela" 
                            required/>
                </mat-form-field>

                <div ngModelGroup="comboTributos" fxFlex="200px">
                    <combo-pesquisavel #comboTributos 
                                        nome="tributos" 
                                        [itens]="tributos" 
                                        itemDescricao="codigo"
                                        itemId="id"
                                        label="Tributo"
                                        [showDisplayId]="false" 
                                        [showDisplayItemLabel]="false"                                        
                                        [obrigatorio]="false"
                                        placeholder="Escolha..."
                                        [(valor)]="fatura.tributoMovimentacao.tributo"
                                        (valorChange)="onValorTributoChange($event)">
                    </combo-pesquisavel>
                </div>

                <mat-form-field fxFlexOffset="20px" fxFlex>
                    <input [(ngModel)]="fatura.tributoMovimentacao.tributo.recebedor"                              
                            name="destinatario" 
                            disabled
                            placeholder="Destinatário" 
                            matInput/>
                </mat-form-field>

            </div>
    
            <div fxLayout="row"  fxFlexFill>
                <mat-form-field fxFlex="100%" fxFlexOffset="20px">
                    <input [(ngModel)]="fatura.codigoBarra" 
                            matInput name="codigoBarra"
                            maxlength="100"
                            placeholder="Código de barra">
                </mat-form-field>
            </div>
                
            
            <div dir="rtl" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="20px"
                style="padding-top: 20px; padding-bottom: 10px; padding-right: 20px" fxFlexFill>

                <button mat-raised-button name="botaoLimpar" fxFlex="20%" color="primary" (click)="limpar()">
                    Limpar
                </button>

                <button *ngIf="!isAtualizar"  mat-raised-button name="botaoAdicionar" 
                        [disabled]="formulario.invalid"   
                        fxFlex="20%" color="primary" (click)="adicionar()">
                    Adicionar
                </button>

                <button *ngIf="isAtualizar" mat-raised-button name="botaoAdicionar"
                        [disabled]="formulario.invalid || valoresSuperiorValorMovimento"  
                        fxFlex="20%" color="primary" (click)="atualizar()">
                    Atualizar
                </button>

            </div>

        </mat-expansion-panel>

        <mat-expansion-panel [expanded]="!openFormCadastro" (opened)="carregarLista()"
            (closed)="openFormCadastro = true">
            <mat-expansion-panel-header>
                <mat-panel-title>
                    <span>Lista de Faturas ( {{movimentacoes.faturas?.length || 0}} ) -</span>
                    <span style="font-weight: 800; padding-left: 10px;" [style.color]="valoresSuperiorValorMovimento ? 'red' : 'green'">Valor Total: {{getValorTotal() | currency: 'BRL'}}</span>      
                    <span *ngIf="valoresSuperiorValorMovimento" style="color: orangered; padding-left: 10px;">ATENÇÃO !!! A soma dos valores das faturas está diferente do valor do movimento.</span>
                </mat-panel-title>
            </mat-expansion-panel-header>

            <table *ngIf="mostrarTabela; else tabelaSemDados" mat-table [dataSource]="dataSource"
                style="margin-top: 20px">

                <ng-container matColumnDef="dataVencimento">
                    <th mat-header-cell *matHeaderCellDef> Data de Vencimento </th>
                    <td mat-cell *matCellDef="let element"> {{element.dataVencimento | dataSimples}} </td>
                </ng-container>

                <ng-container matColumnDef="valor">
                    <th mat-header-cell *matHeaderCellDef> Valor da Fatura </th>
                    <td mat-cell *matCellDef="let element"> {{element.valor | currency: 'BRL'}} </td>
                </ng-container>

                <ng-container matColumnDef="numeroParcela">
                    <th mat-header-cell *matHeaderCellDef> Número de Parcelas </th>
                    <td mat-cell *matCellDef="let element"> {{element.numeroParcela}} </td>
                </ng-container>
               
                <ng-container matColumnDef="tributo">
                    <th mat-header-cell *matHeaderCellDef> Tributo </th>
                    <td mat-cell *matCellDef="let element"> {{element?.tributoMovimentacao?.tributo?.codigo}} </td>
                </ng-container>

                <ng-container matColumnDef="acoes">
                    <th mat-header-cell *matHeaderCellDef > Ações </th>
                    <td mat-cell *matCellDef="let element">
                        <button mat-button (click)="deletar(element)">
                            <mat-icon>delete</mat-icon>
                        </button>
                        <button  mat-button (click)="atualizarRegistro(element)">
                            <mat-icon>create</mat-icon>
                        </button>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>

            <div [hidden]="!mostrarTabela">
                <mat-paginator [pageSizeOptions]="[5]" showFirstLastButtons></mat-paginator>
            </div>

            <ng-template #tabelaSemDados>
                <div fxLayout="row" fxLayoutAlign="center center" style="padding-top: 10px">
                    {{msg}}
                </div>
            </ng-template>

            <div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="16px"
                style="padding-top: 30px">
                <div>
                    <button matTooltip="Adicionar nova fatura" mat-fab color="primary" (click)="novo()">
                        <mat-icon>add</mat-icon>
                    </button>
                </div>
            </div>


        </mat-expansion-panel>

    </mat-accordion> 
</form>
